import { environment } from './../../environments/environment';

export const cacheLifeTime = environment.cacheLifeTime || 30 * 60 * 1000;

export const config = {
  apiUrl: environment.apiUrl,
  appBaseUrl: 'http://localhost:4200/',
  generateApiUrl: function (endpoint, fields?, filters?, apiVersion?) {
    let newEndpoint = this.apiUrl + 'api/' + endpoint;
    let prepareFields = '';
    if (fields) {
      prepareFields += newEndpoint.indexOf('?') > -1 ? '&' : '?';
      prepareFields += 'fields=' + fields.join();
      newEndpoint += prepareFields;
    }

    let prepareFilters = '';
    if (filters) {
      prepareFilters += newEndpoint.indexOf('?') > -1 ? '&' : '?';
      prepareFilters += 'filters=';
      filters.forEach((element, index) => {
        if (index > 0) {
          prepareFilters += ',';
        }
        prepareFilters += element.name + (element.sign || '==') + element.value;

      });
      newEndpoint += prepareFilters;
    }

    let prepareApiVersion = '';
    if (apiVersion) {
      prepareApiVersion += newEndpoint.indexOf('?') > -1 ? '&' : '?';
      prepareApiVersion += 'api-version=' + apiVersion;
      newEndpoint += prepareApiVersion;
    }
    return newEndpoint;
  }
};

export const properties = {
  height: 768,
  width: 0
}

export const DATE_FORMATS_CUSTOM = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'DD.MM.yyyy',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
